import { render } from "./UploadClientDocuments.vue?vue&type=template&id=2e34dde4"
import script from "./UploadClientDocuments.vue?vue&type=script&lang=js"
export * from "./UploadClientDocuments.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__